import React from 'react';
import { Box, Card, CardContent, Typography, Chip } from '@mui/material';

const SectionCard = ({
  title,
  subtitle,
  badge,
  action,
  children,
  sx,
  contentSx,
}) => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 2,
        border: theme => `1px solid ${theme.palette.divider}`,
        bgcolor: 'background.paper',
        boxShadow: '0 0.625rem 1.875rem rgba(15, 23, 42, 0.08)',
        ...sx,
      }}
    >
      {(title || subtitle || action) ? (
        <Box
          sx={{
            px: 2.7,
            py: 1.7,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            {title ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
                  {title}
                </Typography>
                {badge && (
                  <Chip
                    size="small"
                    label={badge}
                    sx={{
                      borderRadius: 999,
                      fontWeight: 700,
                      height: 20,
                      fontSize: '0.7rem',
                      backgroundColor: 'rgba(4, 88, 100, 0.1)',
                      color: 'primary.main',
                      border: 'none'
                    }}
                  />
                )}
              </Box>
            ) : null}
            {subtitle ? (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {subtitle}
              </Typography>
            ) : null}
          </Box>
          {action ? <Box sx={{ flexShrink: 0, pt: 0.25 }}>{action}</Box> : null}
        </Box>
      ) : null}

      {children && (
        <CardContent sx={{ pt: (title || subtitle || action) ? 0 : 2.25, ...contentSx }}>
          {children}
        </CardContent>
      )}
    </Card>
  );
};

export default SectionCard;

